import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import Modal from 'react-responsive-modal'
import CreateEventsPriority from '../../Containers/Events/CreateEventsPriority'
import UpdateEventsPriority from '../../Containers/Events/UpdateEventsPriority'
import EventsActions from '../../Redux/EventsRedux'

class PopularEvents extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'YYYY-MM-DD'
    this.state = {
      showModal: null,
      detail: {}
    }
  }

  componentDidMount = () => {
    this._fetchAllPopularEvents()
  }

  _fetchAllPopularEvents = (event) => {
    if (event) {
      event.preventDefault()
    }
    this.props.getAllPopularEvents()
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _deletePriority = () => {
    let form = {
      is_popular: false,
      priority: 0
    }
    let data = {
      event_id: this.state.detail.event_id,
      form
    }
    this.props.deletePriority(data)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchAllPopularEvents()
    }
  }

  render () {
    const { events } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Popular Events List
              {
                (events.fetching || events.processing) &&
                <div className='badge badge-info ml-2'>{ events.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('create-priority')}>Add Popular Event</button>
          </div>
        </header>
        <section className='section'>
          <div className='card'>
            {
              !(events.fetching || events.processing) && events.err &&
              <div className='alert alert-danger'>{events.err}</div>
            }
            <table className='table table-hover table-striped'>
              <thead>
                <tr>
                  <th className='text-center'>Event Name</th>
                  <th className='text-center'>Organizer</th>
                  <th className='text-center'>Schedule Info</th>
                  <th className='text-center'>Priority</th>
                  <th className='text-center'>Update</th>
                  <th className='text-center'>Delete</th>
                </tr>
              </thead>
              <tbody>
                {
                  !events.data_popular || events.data_popular.length === 0
                    ? <tr>
                      <td colSpan='7' className='text-center'>--No Data--</td>
                    </tr>
                    : events.data_popular.length && events.data_popular.map((item, i) => (
                      <tr key={i}>
                        <td className='align-middle text-center'>
                          <div>
                            <strong>{item.name}</strong>
                          </div>
                          <br />
                          <div>
                            {
                              !item.categories.length
                                ? <button className='btn btn-oval btn-danger'>
                              No Categories
                                </button>
                                : item.categories && item.categories.map((item, i) => (
                                  <button key={i} className='btn btn-oval btn-primary mr-1'>
                                    {item.name}
                                  </button>
                                ))
                            }
                          </div>
                        </td>
                        <td className='align-middle text-center'>{item.organization_name}</td>
                        <td className='align-middle text-center' style={{ width: '70%' }}>
                          {
                            item.schedules.length && item.schedules.map((item, i) => (
                              <table key={i} width='100%'>
                                <tbody>
                                  <tr>
                                    <td><strong>Location</strong>
                                    </td>
                                    <td>{item.location.location_name}</td>
                                  </tr>
                                  <tr>
                                    <td><strong>Address</strong></td>
                                    <td>{item.location.address}</td>
                                  </tr>
                                  <tr>
                                    <td><strong>Start Date</strong></td>
                                    <td>{ moment(item.start_date).format(this.dateformat) }</td>
                                  </tr>
                                  <tr>
                                    <td><strong>End Date</strong></td>
                                    <td>{ moment(item.end_date).format(this.dateformat) }</td>
                                  </tr>
                                </tbody>
                              </table>
                            ))
                          }
                        </td>
                        <td className='align-middle text-center'>
                          <div>
                            <div className='text-center'>
                              <h2>{item.priority}</h2>
                            </div>
                          </div>
                        </td>
                        <td className='text-center align-middle'>
                          <button className='btn btn-primary' onClick={() => this._selectItem(item, 'update-priority')}>
                            <i className='fa fa-edit' /> <strong>Edit</strong>
                          </button>
                        </td>
                        <td className='text-center align-middle'>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-priority')} >
                            <i className='fa fa-trash' />
                          </button>
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
          <Modal open={this.state.showModal === 'create-priority'} onClose={this._toggleModal} closeOnOverlayClick>
            <CreateEventsPriority detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>
          <Modal open={this.state.showModal === 'update-priority'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateEventsPriority detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>
          <Modal open={this.state.showModal === 'delete-priority'} onClose={this._toggleModal} closeOnOverlayClick>
            <section className='section' style={{ width: '40vw' }} >
              <div className='title-block'>
                <h1>Delete Priority?</h1>
              </div>
              <div className='text-center'>
                <h4>{this.state.detail.name}</h4>
              </div>
              <div className='text-center'>
                <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()} >Close</button>
                <button className='btn btn-lg btn-danger' onClick={() => this._deletePriority()} >Delete</button>
              </div>
            </section>
          </Modal>
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  events: state.events
})

const dispatchToProps = (dispatch) => ({
  getAllPopularEvents: (filter) => dispatch(EventsActions.getAllPopularEventsRequest(filter)),
  deletePriority: (data) => dispatch(EventsActions.setPopularEventRequest(data))
})

export default connect(stateToProps, dispatchToProps)(PopularEvents)



// WEBPACK FOOTER //
// ./src/Pages/Events/PopularEvents.js